import { CircleTickIcon } from '../../../assets/icons/CircleTickIcon';

export const applianceCareRadioOptionContent = [
  {
    icon: CircleTickIcon,
    title: 'Accidental damage coverage (includes accessories)',
    description: "Coverage for life's mishaps.",
  },
  {
    icon: CircleTickIcon,
    title: "A replacement if it can't be fixed",
    description: "If we can't fix it, we'll replace it (includes delivery of your new product).",
  },
  {
    icon: CircleTickIcon,
    title: 'Breakdown coverage',
    description: "We'll protect your product after the manufacturer's warranty ends.",
  },
  {
    icon: CircleTickIcon,
    title: 'Unlimited repairs',
    description: 'Get unlimited repairs by authorized technicians, using factory-certified parts.',
  },
  {
    icon: CircleTickIcon,
    title: 'No hidden costs',
    description: 'Zero deductibles on parts and labor.',
  },
];
